import OcomQuoteList from "./pages/ListPage.vue";
import OcomQuoteDetail from "./pages/FormPage.vue";
import OcomQuoteIndex from "./pages/IndexPage.vue";

export default [
  {
    path: "/ocom_quote",
    component: OcomQuoteIndex,
    redirect: "/ocom_quote/list",
    name: "ocom_quote",
    children: [
      {
        path: "list",
        component: OcomQuoteList,
        name: "ocom_quote.list",
      },
      {
        path: "create",
        component: OcomQuoteDetail,
        name: "ocom_quote.create",
        props: { create: true },
      },
      {
        path: "edit/:id",
        component: OcomQuoteDetail,
        name: "ocom_quote.edit",
        props: { create: false },
      },
    ],
  },
];
